import { useTranslation } from 'react-i18next'
import { useGetLeadGroups } from '@/application/services/lead.service'
import { Card, CardContent, CardHeader, CardTitle } from '@/ui/components/common/Card'
import { Skeleton } from '@/ui/components/common/Skeleton'
import { LeadGroupList } from '@/ui/components/leads/LeadGroupList'

/**
 * Wide card showing leads grouped by investigation via `LeadGroupList`,
 * with a loading skeleton and an empty-state message.
 */
export function LeadsByInvestigationSection() {
  const { t } = useTranslation()
  const { data: leadGroups, isLoading } = useGetLeadGroups()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('admin.dash_leads_by_investigation')}</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            <Skeleton className="h-8 w-1/3" />
            <Skeleton className="h-40 w-full" />
          </div>
        ) : leadGroups && leadGroups.length > 0 ? (
          <LeadGroupList groups={leadGroups} showInvestigationDetails />
        ) : (
          <p className="text-sm text-muted-foreground">{t('admin.dash_no_leads')}</p>
        )}
      </CardContent>
    </Card>
  )
}
